import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { UserNotificationPreferenceModel } from '../../models/user-notification-preference.model';

export const UserSettingsActions = createActionGroup({
  source: 'UserSettings',
  events: {
    'Load User Notification Preferences': emptyProps(),
    'Load User Notification Preferences Success': props<{ data: UserNotificationPreferenceModel }>(),
    'Load User Notification Preferences Failure': props<{ error: any }>(),

    'Update User Notification Preferences': props<{ data: UserNotificationPreferenceModel }>(),
    'Update User Notification Preferences Success': emptyProps(),
    'Update User Notification Preferences Failure': props<{ error: any }>(),
  }
});
